import React from 'react';
import { styled } from '@mui/material/styles';
import { darken, lighten, alpha, Stack } from "@mui/material";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.default,     
  '&:hover': {    
    backgroundColor: darken(theme.palette.background.default, 0.07),     
  },
  '&:active': {
    backgroundColor: darken(theme.palette.background.default, 0.1), 
  },
  '&:focus': {
    backgroundColor: darken(theme.palette.background.default, 0.07), 
  },  
  "&.Mui-selected": {
    backgroundColor: darken(theme.palette.background.default, 0.1), 
    '&:hover': {    
      backgroundColor: darken(theme.palette.background.default, 0.3),     
    },
    '&:active': {
      backgroundColor: darken(theme.palette.background.default, 0.3), 
    },
    '&:focus': {
      backgroundColor: darken(theme.palette.background.default, 0.3), 
    },  
  }  
}));

export const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.default,     
  '&:hover': {    
    backgroundColor: darken(theme.palette.background.default, 0.07),     
  },
  '&:active': {
    backgroundColor: darken(theme.palette.background.default, 0.1), 
  },
  '&:focus': {
    backgroundColor: darken(theme.palette.background.default, 0.07), 
  },  
  "&.Mui-selected": {
    backgroundColor: darken(theme.palette.background.default, 0.1), 
    '&:hover': {    
      backgroundColor: darken(theme.palette.background.default, 0.3),     
    },
    '&:active': {
      backgroundColor: darken(theme.palette.background.default, 0.3), 
    },
    '&:focus': {
      backgroundColor: darken(theme.palette.background.default, 0.3), 
    },  
  }  
}));

export const ButtonGroupStyled = styled(ButtonGroup)(({ theme, selected}) => {    
  return {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.default,
    '&:hover': {    
      backgroundColor: darken(theme.palette.background.default, 0.1),       
    },
    '&:active': {
      backgroundColor: darken(theme.palette.background.default, 0.1), 
    },
    '&:focus': {
      backgroundColor: darken(theme.palette.background.default, 0.1), 
    },    
  };
});

export const ButtonStyled = styled(Button)(({ theme, bs4_constructor_mode }) => {
  return {
    color: 'inherit',    
    backgroundColor: 'inherit',   
    "&.MuiButtonGroup-grouped:not(:last-of-type)": {
      borderRightColor: bs4_constructor_mode ? 'transparent' : darken(theme.palette.background.default, 0.2),
    },
    '&:hover': {
      color: 'inherit',
      backgroundColor: 'inherit',
      "&.MuiButtonGroup-grouped:not(:last-of-type)": {
        borderRightColor: bs4_constructor_mode ? 'transparent' : darken(theme.palette.background.default, 0.2),
      },
    },
    '&:active': {
      color: 'inherit',
      backgroundColor: 'inherit',
      "&.MuiButtonGroup-grouped:not(:last-of-type)": {
        borderRightColor: bs4_constructor_mode ? 'transparent' : darken(theme.palette.background.default, 0.2),
      },
    },
    '&:focus': {
      color: 'inherit',
      backgroundColor: 'inherit',
      "&.MuiButtonGroup-grouped:not(:last-of-type)": {
        borderRightColor: bs4_constructor_mode ? 'transparent' : darken(theme.palette.background.default, 0.2),
      },
    },
  }
});

export const ButtonStyledOld = styled(Button)(({ theme }) => ({    
  color: 'inherit',
  backgroundColor: 'inherit',   
  '&:hover': {    
    color: 'inherit',
    backgroundColor: 'inherit',
  },
  '&:active': {
    color: 'inherit',
    backgroundColor: 'inherit',
  },
  '&:focus': {
    color: 'inherit',
    backgroundColor: 'inherit',
  },
}));
